import { render, staticRenderFns } from "./my-uploadLoaction.vue?vue&type=template&id=676337d2&scoped=true"
import script from "./my-uploadLoaction.vue?vue&type=script&lang=js"
export * from "./my-uploadLoaction.vue?vue&type=script&lang=js"
import style0 from "./my-uploadLoaction.vue?vue&type=style&index=0&id=676337d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676337d2",
  null
  
)

export default component.exports